export class ContactValidator {
  public static isValidTrueId(trueId: number | string): boolean {
    if (typeof trueId === 'number' || !isNaN(+trueId)) {
      return +trueId > 0;
    }
    return trueId && trueId !== '0' && trueId !== '-';
  }
}
